import React, { Component } from "react";
import "./index.css";

class ContactUs extends Component {

    componentDidMount() {
        return document.getElementById("Dashboard").scrollTo(0, 0);
    }

    render() {

        return(
            <div className="candidate-contact-page">
                <header className="candidate-contact-header">
                    <p className="candidate-contact-eyebrow">Get in touch</p>
                    <h1 className="candidate-contact-title">We're here to help.</h1>
                    <p className="candidate-contact-subtitle">
                        Questions about a role, your profile, or just want an informal chat about your next move? Use the details below — we'll come back to you fast.
                    </p>
                </header>

                <section className="candidate-contact-section">
                    <h2 className="candidate-contact-section-title">General enquiries</h2>
                    <p className="candidate-contact-section-body">
                        Email <a className="candidate-contact-link" href="mailto:crew@j4crew.com">crew@j4crew.com</a> and the team will get back to you as soon as possible.
                    </p>
                </section>

                <section className="candidate-contact-section">
                    <h2 className="candidate-contact-section-title">Speak to a consultant</h2>
                    <div className="candidate-contact-card">
                        <div className="candidate-contact-card-image">
                            <img src={require("../../../../assets/images/jacob.jpg")} alt="Jacob Hodgson" />
                        </div>
                        <div className="candidate-contact-card-body">
                            <p className="candidate-contact-card-name">Jacob Hodgson</p>
                            <p className="candidate-contact-card-role">Director & Recruitment Consultant</p>
                            <dl className="candidate-contact-card-details">
                                <div className="candidate-contact-card-detail">
                                    <dt>Email</dt>
                                    <dd><a className="candidate-contact-link" href="mailto:jacob@j4crew.com">jacob@j4crew.com</a></dd>
                                </div>
                                <div className="candidate-contact-card-detail">
                                    <dt>Phone</dt>
                                    <dd>
                                        <a className="candidate-contact-link" href="https://wa.me/447598382232" target="_blank" rel="noopener noreferrer">+44 7598 382 232</a>
                                        <span className="candidate-contact-pill">WhatsApp</span>
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </section>
            </div>
        );

    }

}

export default ContactUs;
